import { render } from "./SMGameObject.vue?vue&type=template&id=2370d3f6"
import script from "./SMGameObject.vue?vue&type=script&lang=js"
export * from "./SMGameObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__